import gqlTagGira from 'graphql-tag';

export const MULTIPLE_SELECT_FRAGMENT = gqlTagGira`
    fragment jiraMultipleSelectFieldFragment on JiraMultipleSelectField {
        fieldConfig {
            isEditable
          }
        selectedOptions {
            edges {
                node {
                    optionId
                    value
                }
            }
        }
    }
`;
